import { logisticsConfigSchema } from "@medoma/models/config";
import { logisticsApi } from "./ApiClient";

const configKeys = {
  all: ["config"] as const,
  logistics: () => [...configKeys.all, "logistics"] as const,
};

const fetchLogisticsConfig = async () => {
  return await logisticsApi.get(`/config`).json(logisticsConfigSchema);
};

export const logisticsConfigQueryOptions = () => ({
  queryKey: configKeys.logistics(),
  queryFn: fetchLogisticsConfig,
  staleTime: 1000 * 60 * 60, // 1 hour
});
